import {Component, OnInit} from '@angular/core';
import {UserSettingsService} from './user-settings.service';
import {User} from '../../model/user';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SettingPage} from './setting-page.enum';
import {Dictionary} from '../../model/dictionary';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {NotificationType} from '../notifier/notification-type.enum';
import {CommonService} from '../../common/common.service';
import {NotifierService} from '../notifier/notifier.service';
import {Router} from '@angular/router';
import {NotificationsDictionary} from "../../model/notifications-dictionary";
import {RegisterComponent} from "../register/register.component";
import {LoginService} from "../login/login.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {UserPrivacyService} from "../user-privacy/user-privacy.service";

@Component({
  selector: 'pbc-user-setting',
  templateUrl: './user-setting.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingComponent implements OnInit {

  userSettingsForm : FormGroup;
  contentPreferencesForm : FormGroup;
  agreementsForm : FormGroup;
  safeDomainLogo : any;

  private loggedUserId : string = '';
  userData : User = {
    id : null,
    email : '',
    password : '',
    isAdmin : false,
    isClient : false,
    firstName : '',
    lastName : '',
    lastLoginDate : undefined,
    workPhone : '',
    preferredFormOfContact : '',
    workExperience : 0,
    area : {
      id : null,
      value : '',
      value_1 : '',
      enabled : false,
      dictId : 0
    },
    position : {
      id : null,
      value : '',
      value_1 : '',
      enabled : false,
      dictId : 0
    },
    groups : [],
    interests_products : [],
    interests_institutions : [],
    interests_areas : [],
    interests_client_groups : [],
    interests_publication_frequencies : [],
    notifications : {
      id : null,
      value : '',
      value_1 : '',
      enabled : false,
      dictId : 0
    },
    interest_products_user : '',
    interest_institutions_user : '',
    interest_areas_user : '',
    interest_client_groups_user : '',
    hasRightsToBenchmark : false,
    hasRightsToAlert : false,
    hasRightsToExact : false,
    active : true,
    invitationShownToUser : null,
    personalDataProcessingAgreement : true,
    marketingProcessingAgreement : false
  };

  settingsPage : SettingPage = SettingPage.UserSettings;
  SettingsPageEnum = SettingPage;

  interestProductsSelected : Array<number> =[];
  interestProducts : Array<Dictionary> =[];
  interestInstitutionsSelected : Array<number> =[];
  interestInstitutions : Array<Dictionary> =[];
  interestAreasSelected : Array<number> = [];
  interestAreas : Array<Dictionary> = [];
  interestClientGroupsSelected : Array<number> = [];
  interestClientGroups : Array<Dictionary> = [];
  private interestPublicationFrequenciesSelected : Array<number> = [];
  private interestPublicationFrequencies : Array<Dictionary> = [];

  dictPositions : Array<Dictionary> = [];
  dictUserNotifications : Array<NotificationsDictionary> = [];
  positionHint : string = "";

  showDisableNotificationPopup : boolean = false;
  userNotificationHint : string = "";

  constructor(private userSettingsService : UserSettingsService,
              private commonService : CommonService,
              private router : Router,
              private formBuilder : FormBuilder,
              private loginService : LoginService,
              private notifierService : NotifierService,
              private breadcumbsService: BreadcumbsService,
              private userPrivacyService : UserPrivacyService
              ) {

    let authData = JSON.parse(localStorage.getItem('auth_data'));

    this.loggedUserId = authData.user.id;
    this.getDictionaries();
  }

  ngOnInit() {
    this.createContentPreferencesForm();
    this.createUserSettingsForm();
    this.createAgreementsForm();

    this.commonService.getUser(this.loggedUserId).subscribe (
      result=>{
        if (result.status == 1) {
          this.userData = result.record;

          this.commonService.getSafeDomainLogo(this.userData.email).subscribe(result=>{
            this.createLogoFromBlob(result);
          });

          if (this.userData.interests_institutions)
            this.interestInstitutionsSelected = this.userData.interests_institutions.map(value=>value.id);
          if (this.userData.interests_areas)
            this.interestAreasSelected = this.userData.interests_areas.map(value => value.id);
          if (this.userData.interests_client_groups)
            this.interestClientGroupsSelected = this.userData.interests_client_groups.map(value => value.id);
          if (this.userData.interests_products)
            this.interestProductsSelected = this.userData.interests_products.map(value => value.id);
          if (this.userData.interests_publication_frequencies)
            this.interestPublicationFrequenciesSelected = this.userData.interests_publication_frequencies.map(value=>value.id);

          if (this.userData.workPhone)
            this.userSettingsForm.controls['workPhone'].setValue(this.userData.workPhone);
          else
            this.userSettingsForm.controls['workPhone'].setValue('');

          if (this.userData.preferredFormOfContact)
            this.userSettingsForm.controls['preferredFormOfContact'].setValue(this.userData.preferredFormOfContact);
          else
            this.userSettingsForm.controls['preferredFormOfContact'].setValue('');

          this.userSettingsForm.controls['workExperience'].setValue(this.userData.workExperience);
          if (this.userData.position)
            this.userSettingsForm.controls['position'].setValue(this.userData.position.id);
          if (this.userData.area)
            this.userSettingsForm.controls['area'].setValue(this.userData.area.id);
          this.userSettingsForm.controls['email'].setValue(this.userData.email);
          this.userSettingsForm.controls['firstName'].setValue(this.userData.firstName);
          this.userSettingsForm.controls['lastName'].setValue(this.userData.lastName);

          this.userSettingsForm.markAsPristine();

          this.contentPreferencesForm.controls['notifications'].setValue(this.userData.notifications);
          this.contentPreferencesForm.controls['interestProductUser'].setValue(this.userData.interest_products_user);
          this.contentPreferencesForm.controls['interestInstitutionsUser'].setValue(this.userData.interest_institutions_user);
          this.contentPreferencesForm.controls['interestAreasUser'].setValue(this.userData.interest_areas_user);
          this.contentPreferencesForm.controls['interestClientGroupsUser'].setValue(this.userData.interest_client_groups_user);

          this.contentPreferencesForm.markAsPristine();

          this.agreementsForm.controls['personalDataProcessingAgreement'].setValue(this.userData.personalDataProcessingAgreement);
          this.agreementsForm.controls['marketingProcessingAgreement'].setValue(this.userData.marketingProcessingAgreement);
          this.agreementsForm.markAsPristine();

          if (this.userData.position)
            this.positionHint = this.userData.position.value_1;

          if (this.userData.notifications)
            this.userNotificationHint = this.userData.notifications.value_1;
          this.breadcumbsService.setSubfolder.emit('Ustawienia');
        }
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można pobrać danych użytkownika");
        this.breadcumbsService.setSubfolder.emit('Ustawienia');
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można pobrać danych użytkownika");
        this.breadcumbsService.setSubfolder.emit('Ustawienia');
      }
    );

    this.settingsPage = SettingPage.UserSettings;
  }

  private addRemoveUserPreference(preference : Dictionary, preferencesList : Array<number>) {
    let position = preferencesList.indexOf(preference.id);
    if (position == -1)
      preferencesList.push(preference.id);
    else
      preferencesList.splice(position, 1);

    this.contentPreferencesForm.markAsDirty();
  }

  private getDictionaries() {
    forkJoin(
      this.commonService.getAreaDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getPositionDictionary(),
      this.commonService.getNotificationFrequencyDictionary()
    ).subscribe(([areas, clientGroups, institutions, products, frequencies, positions, notifications]) => {
        this.interestAreas= areas;
        this.interestClientGroups = clientGroups;
        this.interestInstitutions = institutions;
        this.interestProducts= products;
        this.interestPublicationFrequencies= frequencies;
        this.dictPositions = positions;
        // @ts-ignore
        this.dictUserNotifications = notifications;
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
        console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
      });
  }

  private createAgreementsForm() {
    this.agreementsForm = new FormGroup({
      'personalDataProcessingAgreement' : new FormControl({value: true, disabled: true}, Validators.requiredTrue),
      'marketingProcessingAgreement' : new FormControl('', Validators.required)
    })
  }

  private createUserSettingsForm() {
    this.userSettingsForm = new FormGroup({
      'email' : new FormControl({value:'', disabled:true}, [Validators.email, Validators.required]),
      'firstName' : new FormControl({value:'', disabled:true}, Validators.required),
      'lastName' : new FormControl({value:'', disabled:true}, Validators.required),
      'password' : new FormControl({value:'', disabled:true}, Validators.required),
      'workPhone' : new FormControl(''),
      'preferredFormOfContact' : new FormControl('', Validators.required),
      'workExperience' : new FormControl('', [this.validateInteger, Validators.max(50), Validators.min(0)]),
      'position' : new FormControl('', Validators.required),
      'area' : new FormControl('')
    })
  }

  private createContentPreferencesForm() {
    this.contentPreferencesForm = new FormGroup({
      'notifications' : new FormControl(''),
      'interestProductUser' : new FormControl(''),
      'interestInstitutionsUser' : new FormControl(''),
      'interestAreasUser' : new FormControl(''),
      'interestClientGroupsUser' : new FormControl(''),
    });
  }

  setSettingsPage(settingsPage : SettingPage) {
    this.settingsPage = settingsPage;
  }

  saveUserData() {

    let requestParams : any = {};

    requestParams.id = this.loggedUserId;
    requestParams.workPhone = this.userSettingsForm.controls['workPhone'].value;
    requestParams.preferredFormOfContact = this.userSettingsForm.controls['preferredFormOfContact'].value;
    requestParams.workExperience = this.userSettingsForm.controls['workExperience'].value;
    requestParams.position = this.userSettingsForm.controls['position'].value;
    requestParams.area = this.userSettingsForm.controls['area'].value;

    this.userSettingsService.userUpdate(requestParams).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można zapisać danych użytkownika");
        else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Dane użytkownika zostały zapisane");
          this.userData = result.record;
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można zapisać danych użytkownika");
      }
    );
  }

  saveUserAgreementsClick() {
    let requestParams : any = {};

    requestParams.id = this.loggedUserId;
    requestParams.marketingProcessingAgreement = this.agreementsForm.controls['marketingProcessingAgreement'].value;

    this.userSettingsService.userUpdate(requestParams).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można zapisać danych użytkownika");
        else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Dane użytkownika zostały zapisane");
          this.userData = result.record;

          this.agreementsForm.markAsUntouched();
          this.agreementsForm.markAsPristine();
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można zapisać danych użytkownika");
      }
    );
  }

  saveUserContentPreferencesClick() {
    let userNotification = this.contentPreferencesForm.controls['notifications'].value;

    if (this.areNotificationsDisabled(userNotification))
      this.showDisableNotificationPopup = true;
    else {
        this.showDisableNotificationPopup = false;
        this.saveUserContentPreferences();
        this.contentPreferencesForm.markAsUntouched();
        this.contentPreferencesForm.markAsPristine();
      }
  }

  saveUserContentPreferences(notificationsFrequencyId? : number) {
    let requestParams : any = {};

    requestParams.id = this.loggedUserId;
    requestParams.interests_products = this.interestProductsSelected;
    requestParams.interests_institutions = this.interestInstitutionsSelected;
    requestParams.interests_areas = this.interestAreasSelected;
    requestParams.interests_client_groups = this.interestClientGroupsSelected;
    requestParams.interests_publication_frequencies  =  this.interestPublicationFrequenciesSelected;

    requestParams.interest_products_user = this.contentPreferencesForm.controls['interestProductUser'].value;
    requestParams.interest_institutions_user = this.contentPreferencesForm.controls['interestInstitutionsUser'].value;
    requestParams.interest_areas_user = this.contentPreferencesForm.controls['interestAreasUser'].value;
    requestParams.interest_client_groups_user = this.contentPreferencesForm.controls['interestClientGroupsUser'].value;

    if (notificationsFrequencyId)
      requestParams.notifications = notificationsFrequencyId;
    else
      requestParams.notifications = this.contentPreferencesForm.controls['notifications'].value;

    this.userSettingsService.userUpdate(requestParams).subscribe(
      result => {
        if (result.status !=1) {
          console.log(result.record);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie można zapisać danych użytkownika");
        }
        else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Preferencje zostały zapisane");
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie można zapisać danych użytkownika");
      }
    );
  }

  allProductsClick() {
    if (this.interestProductsSelected.length == this.interestProducts.length)
      this.interestProductsSelected = [];
    else
      this.interestProducts.forEach(product => {
        if (this.interestProductsSelected.indexOf(product.id)==-1)
          this.interestProductsSelected.push(product.id);
      });

     this.contentPreferencesForm.markAsDirty();
  }

  allInstitutionsClick() {
    if (this.interestInstitutionsSelected.length == this.interestInstitutions.length)
      this.interestInstitutionsSelected = [];
    else
      this.interestInstitutions.forEach(institution=>{
        if (this.interestInstitutionsSelected.indexOf(institution.id) == -1)
          this.interestInstitutionsSelected.push(institution.id);
      });

     this.contentPreferencesForm.markAsDirty();
  }

  allThematicsAreaClick() {
    if (this.interestAreasSelected.length == this.interestAreas.length)
      this.interestAreasSelected = [];
    else
      this.interestAreas.forEach(area=>{
        if (this.interestAreasSelected.indexOf(area.id) == -1)
          this.interestAreasSelected.push(area.id)
      });

     this.contentPreferencesForm.markAsDirty();
  }

  allClientGroupsSelected() {
    if (this.interestClientGroupsSelected.length == this.interestClientGroups.length)
      this.interestClientGroupsSelected = [];
    else
      this.interestClientGroups.forEach(group=>{
        if (this.interestClientGroupsSelected.indexOf(group.id)==-1)
          this.interestClientGroupsSelected.push(group.id);
      });

     this.contentPreferencesForm.markAsDirty();
  }

  createLogoFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.safeDomainLogo = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  askForOfferClick() {
    this.router.navigate(['user-contact'])
  }

  positionChange() {
    this.positionHint = "";
    let positionSelected = this.userSettingsForm.controls['position'].value;

    for (let i = 0; i < this.dictPositions.length; i ++ )
      if (this.dictPositions[i].id === positionSelected) {
        this.positionHint = this.dictPositions[i].value_1;
        break
      }
  }

  closeDisableNotificationPopup() {
    this.showDisableNotificationPopup = false;
  }

  private setSporadicNotificationsClick() {
    let freqId = this.getSporadicNotificationsId();
    this.saveUserContentPreferences(freqId);
    this.contentPreferencesForm.controls['notifications'].setValue(freqId);
    this.notificationFrequencyChange(null);
    this.showDisableNotificationPopup = false;
    this.contentPreferencesForm.markAsUntouched();
    this.contentPreferencesForm.markAsPristine();
  }

  private setNoNotificationsClick() {
    this.saveUserContentPreferences();
    this.showDisableNotificationPopup = false;
    this.contentPreferencesForm.markAsUntouched();
    this.contentPreferencesForm.markAsPristine();
  }

  notificationFrequencyChange(tooltip) {
    this.userNotificationHint = "";

    if (tooltip.isOpen()) {
      tooltip.close();
    }
    let notification = Number(this.contentPreferencesForm.controls['notifications'].value);
    for (let i = 0; i < this.dictUserNotifications.length; i++)
      if (this.dictUserNotifications[i].id === notification) {
        this.userNotificationHint = this.dictUserNotifications[i].value_1;
        break;
      }
    let hint = this.userNotificationHint;
    tooltip.open({hint});

  }


  private areNotificationsDisabled(id : number) : boolean {
    for (let i = 0; i < this.dictUserNotifications.length; i++) {
      if (this.dictUserNotifications[i].id == id)
        return this.dictUserNotifications[i].disableNotifications;
    }

    return false;
  }

  private getSporadicNotificationsId() : number {
    for (let i = 0; i < this.dictUserNotifications.length; i++) {
      if (this.dictUserNotifications[i].sporadicNotifications)
        return this.dictUserNotifications[i].id;
    }
  }

  private validateInteger = (control:FormControl) => {
    if (control.value && control.value.length>0) {
      return RegisterComponent.isInteger(control.value) ? null : {
        notNumeric: true
      }
    } else {
      return null;
    }
  };

  onChangePasswordClick() {
    this.router.navigate(['/change-password']);
    this.loginService.logout();
  }

  showPrivacyClick() {
    this.userPrivacyService.showUserPrivacy.emit(true);
  }
}
